import {Component, OnInit} from '@angular/core';

import {
    IconService,
    SettingsService,
    SettingsTilesService,
    SubtitlesService
} from "../../core";

@Component({
    selector: 'settings-tiles',
    templateUrl: './settings-tiles.component.html',
    styleUrls: ['./settings-tiles.component.scss']
})
export class SettingsTilesComponent {
    constructor(
        public icon: IconService,
        public settings: SettingsService,
        public settingsTiles: SettingsTilesService,
        private subtitles: SubtitlesService,
    ) {
    }

    subtitle(val: number): string {
        return val !== 0 ? this.subtitles.setSubtitle(val) : '';
    }

    settingsHasModules(): boolean {
        return Array.isArray(this.settings.modules) && this.settings.modules.length > 0
    }
}
